module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ks_lb1@2x.8395cad6.png";